const { screens } = require("@clockwise/design-system/src/themes/extend/screens");

const convertRawPixelToNumber = (rawValue: string): number | undefined => {
  const suffix = "px";
  if (!rawValue.includes(suffix)) {
    return;
  }

  return Number(rawValue.split("px")[0]);
};

export const tailwindScreenSize = (screenSize: keyof typeof screens): number | undefined => {
  const rawScreenSize = screens[screenSize];

  if (!rawScreenSize) {
    return;
  }

  return convertRawPixelToNumber(rawScreenSize);
};
